module.exports = __webpack_public_path__ + "front/img/2_a.cd14c100.png";